/* eslint-disable max-lines */
import { selectConfigValue } from '../../../../shared/selectors/config';

const RETURN_URL = `${window.location.origin}/razmestit-obyavlenie/`;

export const IDENTIFICATION_STATUS = {
  WAIT_FOR_CONFIRM: 'WAIT_FOR_CONFIRM',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  ERROR: 'ERROR',
};

export const USER_IDENTIFICATION_STATUS = {
  OK: 'okNoIdentificationNeeded',
  WAIT: 'notIdentified',
  NO: 'needIdentification',
  ERROR: 'ERROR',
  NEED_TO_DRAFT: 'needIdentificationSetToDraft',
  PROCESS_TO_DRAFT: 'notIdentifiedSetToDraft',
};

const PAYMENT_INIT_SOURCE = 'publishObjectIdentification';
/**
 * Сервис для идентификации пользователя с проверкой паспорта через sumsub
 */
export default [
  '$q',
  '$http',
  'addFormService',
  '$rootScope',
  'analyticsService',
  'popupService',
  '$interval',
  'geoService',
  'store',
  function ($q, $http, addFormService, $rootScope, analyticsService, popupService, $interval, geoService, store) {
    let that = this;
    let _applicantId = null;
    let _accessToken = null;

    let isVisible = false;
    let isSelectPageVisible = false;
    let isUserNeedIdentification = false;

    let completeCallback = null;

    let userStatusByAd = null;
    let userRegionIdByAd = null;
    let isOnlyDraftEnabled = false;

    // Черновик в процессе сохранения
    let isSaveInProcess = false;

    let draftId = null;

    let identifitactionLink = '';

    let postDraftSaveCallback = null;

    that.userStatus = 'notIdentified';
    let taskList = [];

    const getIdentificationLink = () => {
      return identifitactionLink;
    };

    const setIdentificationLink = link => {
      identifitactionLink = link;
    };

    const getPostDraftSaveCallback = () => {
      return postDraftSaveCallback;
    };

    const setPostDraftSaveCallback = callback => {
      postDraftSaveCallback = callback;
    };

    const getApplicantId = () => {
      return _applicantId;
    };

    const setApplicantId = val => {
      _applicantId = val;
    };

    const getIsUserNeedIdentification = () => {
      return isUserNeedIdentification;
    };

    const setIsUserNeedIdentification = val => {
      isUserNeedIdentification = !!val;
    };

    const getDraftId = () => {
      return draftId;
    };

    const setDraftId = val => {
      draftId = val;
    };

    const setAccessToken = val => {
      _accessToken = val;
    };

    const getAccessToken = () => {
      return _accessToken;
    };

    const getIsSelectPageVisible = () => {
      return isSelectPageVisible;
    };

    const setIsSelectPageVisible = val => {
      isSelectPageVisible = !!val;
    };

    const getIsVisible = () => {
      return isVisible;
    };

    const setIsVisible = val => {
      isVisible = !!val;
    };

    const getIsOnlyDraftEnabled = () => {
      return isOnlyDraftEnabled;
    };

    const setIsOnlyDraftEnabled = val => {
      isOnlyDraftEnabled = !!val;
    };

    const getIsSaveInProcess = () => {
      return isSaveInProcess;
    };

    const setIsSaveInProcess = val => {
      isSaveInProcess = !!val;
    };

    const getUserStatusByAd = () => {
      return userStatusByAd;
    };

    const getUserRegionIdByAd = () => {
      return userRegionIdByAd;
    };

    const setTaskList = val => {
      taskList = val;
    };

    const getTaskList = () => {
      return taskList;
    };

    const setUserStatus = val => {
      that.userStatus = val;
    };

    const getUserStatus = () => {
      return that.userStatus;
    };

    const setCompleteCallback = ({ success, error, expired }) => {
      completeCallback = { success, error, expired };
    };

    const getCompleteCallback = (type, params) => {
      return typeof completeCallback[type] === 'function' ? completeCallback[type](params) : null;
    };

    const state = store.getState();
    const identificationOrchestratorBrowserUrl = selectConfigValue('identificationOrchestratorBrowserUrl', state);
    const announcementsSumSubBrowserUrl = selectConfigValue('announcementsSumSubBrowserUrl', state);
    const billingAccountsBrowserUrl = selectConfigValue('billingAccountsBrowserUrl', state);

    /**
     * Получение доступных способов идентификации
     */
    const requestIdentificationServices = () => {
      const locationPath = geoService.getLocationPath();
      const headers = {
        'Cache-Control': undefined,
        Pragma: undefined,
      };
      const params = {
        locationPath: `${locationPath[locationPath.length - 1]}`,
      };

      const res = $http.get(identificationOrchestratorBrowserUrl + '/v2/get-identification-services-desktop/', {
        headers,
        withCredentials: true,
        params,
      });

      return res;
    };

    /**
     * Получение текущего статуса идентификации
     */
    const requestIdentificationStatus = data => {
      const headers = {
        'Cache-Control': undefined,
        Pragma: undefined,
      };

      $http
        .get(identificationOrchestratorBrowserUrl + '/v1/get-identification-status/', {
          headers,
          withCredentials: true,
          params: { identificationServiceType: data },
        })
        .then(response => {
          if (response) {
            setUserStatus(response.data.status);
          }
        });
    };

    /**
     * Получение идентификационных данных пользователя в subsum-е
     */
    const requestIdentificationData = () =>
      $http.post(announcementsSumSubBrowserUrl + '/v1/add-applicant/', {}, { withCredentials: true });

    /**
     * Получение токена в subsum-е
     */
    const requestIdentificationAccessToken = () =>
      $http.post(announcementsSumSubBrowserUrl + '/v1/get-access-token/', {}, { withCredentials: true });

    /**
     * Отправили все документы в subsum, уведомляем монолит
     */
    const sentPassportIdentification = () =>
      $http.post(announcementsSumSubBrowserUrl + '/v1/edit-user-docs-sent/', {}, { withCredentials: true });

    /**
     *  Сбрасываем статус идентификации
     */
    const resetIdentificationServiceStatus = identificationServiceType =>
      $http.post(
        identificationOrchestratorBrowserUrl + '/v1/reset-identification-service-status/',
        { identificationServiceType },
        { withCredentials: true },
      );

    /**
     *  Получаем URL редиректа для подтверждения карты
     */
    const postDepositAmountIdentification = callbackUrl =>
      $http.post(
        billingAccountsBrowserUrl + 'v1/deposit-amount-identification/',
        { callbackUrl, paymentInitSource: PAYMENT_INIT_SOURCE },
        { withCredentials: true },
      );

    const checkAvailableTasks = $scope => {
      const deferred = $q.defer();

      requestIdentificationServices()
        .then(response => {
          if (response.data.services.length) {
            setTaskList(response.data.services);
            if (response.data.services.length === 1) {
              onSelectIdentification(response.data.services[0]);
            } else {
              setIsSelectPageVisible(true);
            }
            if ($scope) {
              $scope.$apply();
            }
            deferred.resolve();
          } else {
            deferred.reject();
          }
        })
        .catch(() => {
          deferred.reject();
        });

      return deferred.promise;
    };

    const checkUserIdentification = () => {
      const deferred = $q.defer();

      $q.all([requestIdentificationAccessToken(), requestIdentificationData()])
        .then(response => {
          if (response && response[0] && response[0].data && response[1] && response[1].data) {
            setAccessToken(response[0].data.token);
            setApplicantId(response[1].data.applicantId);
            setIsVisible(true);
            deferred.resolve();
          } else {
            deferred.reject();
          }
        })
        .catch(() => {
          deferred.reject();
        });

      return deferred.promise;
    };

    /**
     * Опредяет, нужна ли пользователю для размещения объявления идентификация по паспорту (sumsub).
     */
    const markDraftAsNeedIdentification = objectId => {
      const ad = addFormService && addFormService.ad;
      const deferred = $q.defer();

      if (!ad) {
        deferred.resolve(false);
      } else {
        const params = {
          objectId,
          objectGuid: ad.objectGuid,
          regionId: userRegionIdByAd,
        };

        $http({
          method: 'POST',
          url: `${identificationOrchestratorBrowserUrl}/v1/mark-announcement-drafted-by-identification/`,
          headers: { 'Content-Type': 'application/json' },
          data: params,
          allowServerErrors: true,
          withCredentials: true,
        })
          .then(() => {
            deferred.resolve();
          })
          .catch(() => {
            deferred.reject();
          });
      }

      return deferred.promise;
    };

    /**
     * Сброс identificationRequest
     */
    let identificationRequest;

    const resetGosuslugiPromise = () => {
      $interval.cancel(identificationRequest);
    };

    /**
     * Выбор способа идентификации
     */
    function onSelectIdentification(task) {
      if (task.type === 'iframe') {
        popupService.openPopup('identification', {
          iframeUrl: task.iframeUrl,
        });
      } else if (task.type === 'bankCard') {
        const w = window.open('', '_self');
        postDepositAmountIdentification(RETURN_URL).then(({ data }) => {
          if (data && data.redirectUrl) {
            w.location = data.redirectUrl;
          }
        });
      } else {
        window.open(task.iframeUrl);
        resetIdentificationServiceStatus(task.identificationServiceType).then(() => {
          identificationRequest = $interval(
            requestIdentificationStatus,
            2000,
            150,
            true,
            task.identificationServiceType,
          );
        });
      }
    }

    return {
      IDENTIFICATION_STATUS,
      USER_IDENTIFICATION_STATUS,
      getUserStatusByAd,
      getUserRegionIdByAd,
      getDraftId,
      setDraftId,
      getApplicantId,
      getAccessToken,
      getIsSelectPageVisible,
      setIsSelectPageVisible,
      getIsVisible,
      setIsVisible,
      getIsSaveInProcess,
      setIsSaveInProcess,
      getIsOnlyDraftEnabled,
      setIsOnlyDraftEnabled,
      getIsUserNeedIdentification,
      setIsUserNeedIdentification,
      getCompleteCallback,
      setCompleteCallback,
      checkUserIdentification,
      sentPassportIdentification,
      markDraftAsNeedIdentification,
      getIdentificationLink,
      setIdentificationLink,
      requestIdentificationServices,
      requestIdentificationStatus,
      setTaskList,
      getTaskList,
      checkAvailableTasks,
      getUserStatus,
      setUserStatus,
      userStatus: that.userStatus,
      resetIdentificationServiceStatus,
      onSelectIdentification,
      resetGosuslugiPromise,
      setPostDraftSaveCallback,
      getPostDraftSaveCallback,
    };
  },
];
